import { useEffect } from "react";

export const SITE_URL = "https://wgroupconsulting.co.uk";

export function usePageMeta(title: string, description: string, path: string) {
  useEffect(() => {
    document.title = title;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", description);
    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = `${SITE_URL}${path}`;
  }, [title, description, path]);
}
